module.exports = __webpack_public_path__ + "img/m1.4fbc249c.png";